import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  IconButton,
  Typography
} from '@mui/material'
import { ProductoWProps } from '../Producto'
import ProductoActions from '../ProductoActions'
import ButtonDesplegable from '../../../../../components/Common/ButtonDesplegable'
import DesplegableRubrosProducto from '../DesplegableRubrosProducto'
import { format } from 'date-fns'
import CloseIcon from '@mui/icons-material/Close'
import { useContext } from 'react'
import { ProductosAdminContext } from '../../../context/productos.context'
import CardActionsArea from '../../../../Products/components/Mobile/Card/CardActionsArea'
import VisibilityIcon from '@mui/icons-material/Visibility'

const CardProducto = ({
  producto,
  rubros,
  loading,
  loadingVideo,
  changingEstado,
  loadingRubros,
  setOpenDuplicar,
  setOpenMotivos,
  labelRevision,
  isDefinitivelyDeleting,
  isDefinitivelyExpiring,
  cambiarRubro,
  isSelected,
  setIsSelected,
  eliminarRevision
}: ProductoWProps) => {
  const { productosSeleccionados, setProductosSeleccionados } = useContext(ProductosAdminContext)

  const handleActionAreaClick = () => window.open(producto.sharelink, '_blank')

  return (
    <Card
      onContextMenu={(e) => e.preventDefault()}
      sx={{
        width: 350,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: '2px solid',
        userSelect: 'none'
      }}
    >
      <CardActionsArea
        product={producto}
        handleActionAreaClick={handleActionAreaClick}
        loadingVideo={loadingVideo}
        productosSeleccionados={productosSeleccionados}
        setProductosSeleccionados={setProductosSeleccionados}
        isAdmin
      />
      <CardHeader
        sx={{
          backgroundColor:
            producto.aprobado && !producto.pausado && !producto.vencido
              ? '#b3faa8'
              : producto.rechazado
                ? '#ffaeba'
                : producto.pausado || producto.vencido
                  ? '#ddd'
                  : '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
        action={
          <Box sx={{ color: 'text.secondary' }}>
            {loading ? (
              <CircularProgress size={20} sx={{ marginRight: '1rem' }} />
            ) : (
              <ButtonDesplegable color="inherit" variant="text">
                <ProductoActions
                  changingEstado={changingEstado}
                  setOpenDuplicar={setOpenDuplicar}
                  isDefinitivelyDeleting={isDefinitivelyDeleting}
                  isDefinitivelyExpiring={isDefinitivelyExpiring}
                  producto={producto}
                />
              </ButtonDesplegable>
            )}
          </Box>
        }
        title={producto.nombre}
        titleTypographyProps={{ variant: 'body1' }}
        subheader={`${producto.nombreLocal} - (${producto.codLocal})`}
        subheaderTypographyProps={{ variant: 'body2' }}
      />
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <Typography variant="body2" color="darkblue">
            <span>
              {`May: ${producto.precio}`}
              <br />
              {producto.informacionPrecio}
            </span>
            {producto.precioMinorista > 0 && (
              <span>
                <br />
                {`Min: ${producto.precioMinorista}`}
                <br />
              </span>
            )}
          </Typography>
          <Typography variant="body2" color="darkblue" style={{ whiteSpace: 'break-spaces' }}>
            {`Pub: ${format(new Date(producto.fechaPublicacion), 'dd/MM/yyyy HH:mm')}\nVto: ${format(
              new Date(producto.fechaVencimiento),
              'dd/MM/yyyy'
            )}`}
          </Typography>
          <Typography variant="body2" color="gray" sx={{ marginTop: '10px' }}>
            {producto.flags}
          </Typography>
        </div>
        {producto.motivosRevision?.length > 0 && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              border: '1px solid red',
              color: 'red',
              borderRadius: '4px',
              height: '2rem'
            }}
          >
            <Typography style={{ padding: '0 0.5rem', fontSize: '12px', whiteSpace: 'nowrap' }}>
              {labelRevision}
            </Typography>
            <IconButton size="small" color="error" onClick={() => setOpenMotivos(true)}>
              <VisibilityIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" color="error" onClick={eliminarRevision}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        )}
      </CardContent>
      {/* Se alinea verticalmente al final del rubro */}
      <Box sx={{ flexGrow: 1 }} />
      <CardActions>
        <DesplegableRubrosProducto
          rubros={rubros}
          loading={loadingRubros}
          onChange={cambiarRubro}
          nombreRubro={producto.nombreRubro}
          codActual={producto.codRubro}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
        />
      </CardActions>
    </Card>
  )
}

export default CardProducto
